<div class="w-full px-2">
  <div class="relative h-2">
    <div class="absolute w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
    <div class="absolute h-2 bg-brand dark:bg-brand rounded-lg" [style.left.%]="getMinPercent()" [style.width.%]="getActiveWidth()"></div>

      <div [ngStyle]="getMinTooltipStyle()" class="px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap pointer-events-none z-[9999] transition-transform duration-300 ease-in-out">
        {{ formatValue(minValue()) }}
        <div class="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-gray-900"></div>
      </div>

    <label aria-label="Range min" (mouseenter)="showMinTooltip()" (mouseleave)="showMinTooltip()">
      <input #minInput
        type="range"
        [min]="rangeMin()"
        [max]="rangeMax()"
        [step]="calculatedStep()"
        [value]="minValue()"
        (input)="onMinChange($event)"
        class="absolute w-full h-2 appearance-none bg-transparent pointer-events-none z-10
                   [&::-webkit-slider-thumb]:appearance-none
                   [&::-webkit-slider-thumb]:w-5
                   [&::-webkit-slider-thumb]:h-5
                   [&::-webkit-slider-thumb]:rounded-full
                   [&::-webkit-slider-thumb]:bg-white
                   [&::-webkit-slider-thumb]:border-2
                   [&::-webkit-slider-thumb]:border-brand
                   [&::-webkit-slider-thumb]:cursor-pointer
                   [&::-webkit-slider-thumb]:pointer-events-auto
                   [&::-webkit-slider-thumb]:shadow-md
                   [&::-webkit-slider-thumb]:hover:bg-brand-softer
                   [&::-moz-range-thumb]:w-5
                   [&::-moz-range-thumb]:h-5
                   [&::-moz-range-thumb]:rounded-full
                   [&::-moz-range-thumb]:bg-white
                   [&::-moz-range-thumb]:border-2
                   [&::-moz-range-thumb]:border-brand
                   [&::-moz-range-thumb]:cursor-pointer
                   [&::-moz-range-thumb]:pointer-events-auto
                   [&::-moz-range-thumb]:shadow-md
                   [&::-moz-range-thumb]:hover:bg-brand-softer"/>
    </label>

    <div [ngStyle]="getMaxTooltipStyle()" class="px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap pointer-events-none z-[9999] transition-transform duration-300 ease-in-out">
      {{ formatValue(maxValue()) }}
      <div class="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-gray-900"></div>
    </div>

    <label aria-label="Range max" (mouseenter)="showMaxTooltip()" (mouseleave)="showMaxTooltip()">
      <input #maxInput
        type="range"
        [min]="rangeMin()"
        [max]="rangeMax()"
        [step]="calculatedStep()"
        [value]="maxValue()"
        (input)="onMaxChange($event)"
        class="absolute w-full h-2 appearance-none bg-transparent pointer-events-none z-20
                   [&::-webkit-slider-thumb]:appearance-none
                   [&::-webkit-slider-thumb]:w-5
                   [&::-webkit-slider-thumb]:h-5
                   [&::-webkit-slider-thumb]:rounded-full
                   [&::-webkit-slider-thumb]:bg-white
                   [&::-webkit-slider-thumb]:border-2
                   [&::-webkit-slider-thumb]:border-brand
                   [&::-webkit-slider-thumb]:cursor-pointer
                   [&::-webkit-slider-thumb]:pointer-events-auto
                   [&::-webkit-slider-thumb]:shadow-md
                   [&::-webkit-slider-thumb]:hover:bg-brand-softer
                   [&::-moz-range-thumb]:w-5
                   [&::-moz-range-thumb]:h-5
                   [&::-moz-range-thumb]:rounded-full
                   [&::-moz-range-thumb]:bg-white
                   [&::-moz-range-thumb]:border-2
                   [&::-moz-range-thumb]:border-brand
                   [&::-moz-range-thumb]:cursor-pointer
                   [&::-moz-range-thumb]:pointer-events-auto
                   [&::-moz-range-thumb]:shadow-md
                   [&::-moz-range-thumb]:hover:bg-brand-softer"/>
    </label>
  </div>

  <!-- Min/Max Labels -->
  <div class="flex justify-between mt-2">
    <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatValue(rangeMin()) }}</span>
    <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatValue(rangeMax()) }}</span>
  </div>
</div>
